import React from "react";
import "../styles/home.css";
import Navbar from "../components/BlogNavbar";
import Elevate from "../components/ElevateSection";

const Home = () => {
  return (
    <div className="home">
      <Navbar />
      <Elevate />
    </div>
  );
};

export default Home;
